<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
           <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                        <el-table-column prop="id" label="编号"></el-table-column>
                        <el-table-column prop="name" label="维度"></el-table-column>
                        <el-table-column prop="sort" label="排序"></el-table-column>
                        <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="add_by" label="添加人"></el-table-column>
                        <el-table-column label="操作" width="130" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                                    @click="handleEdit(scope.row,scope.$index)"></el-button>
                                    <el-button size="mini" type="danger" icon="el-icon-delete"
                                    @click="handleDelet(scope.row,scope.$index)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <el-dialog title="维度设置" :visible.sync="dialogVisible" center width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="维度名称" prop='sz_name' >
                        <el-input v-model="ruleForm.sz_name"  size="small"  ></el-input>
                     </el-form-item>
                     <el-form-item label="排序" >
                        <el-input v-model="ruleForm.sz_sort" size="small" type="number"> </el-input>
                     </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
       
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                eid:'0',
                dialogVisible:false,
                subloading:false,
                ruleForm:{
                    sz_name:'',
                    sz_sort:50
                },
                rule:{
                    sz_name:[{ required: true, message: '请填写维度名称', trigger: 'blur' }],
                }
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
           let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage=1
                that.pagesize=15
                that.search()
            },
            search() {
                let that = this
                that.tableData=[]
                that.loading = true
                axios.post("/admin/knowledgecategory/list", {
                        page: that.currentPage,
                        page_count:that.pagesize
                    },{token:true})
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd(){
                let that = this
                that.dialogVisible=true
                that.eid='0'
                that.form_clear()
            },
            form_clear(){
              let that=this
              that.ruleForm.sz_name=''
              that.ruleForm.sz_sort=50
            },
            submit(formName){
                let that=this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading=true
                        let urls;
                        if(this.eid&&this.eid!='0'){
                           urls="/admin/knowledgecategory/update" 
                        }else{
                            urls="/admin/knowledgecategory/save" 
                        }
                        axios.post(urls, {
                            id:that.eid,
                            name:that.ruleForm.sz_name,
                            author:this.user.id,
                            sort: that.ruleForm.sz_sort
                        },{token:true})
                        .then(response => {
                            that.subloading=false
                            if(response.data.code=='200'){
                                that.dialogVisible=false
                                that.search()
                            }else{
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {}) 
                    } else {
                        return false;
                    }
                });  
            },
            // 编辑
            handleEdit(row,index){
                let that=this
                that.form_clear()
                that.dialogVisible=true
                that.eid=row.id
                axios
                    .post("/admin/knowledgecategory/read", {
                        id:that.eid,
                    },{token:true})
                    .then(response => {
                        var data=response.data.data
                        that.ruleForm.sz_name=data.name
                        that.ruleForm.sz_sort=data.sort
                    })
                    .catch(error => {}) 
            },
            // 删除
            handleDelet(row,index){
                let that=this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/knowledgecategory/del", {
                            id:row.id,
                        },{token:true})
                        .then(response => {
                            if(response.data.code=='200'){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            }else{
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {}) 
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        },

    };
</script>


<style scoped>
</style>